module.exports = [{"name":"TypeScript","path":"/typescript"},{"name":"Elm","path":"/elm"}]


//////////////////
// WEBPACK FOOTER
// ./src/contents.json
// module id = 314
// module chunks = 114276838955818